<template>
  <nav class="navbar navbar-expand-lg theme-nav fixed-top">
    <div class="container">
      <router-link class="navbar-brand" to="/chatloop"
        ><img src="../assets/images/logo.png" alt="logo"
      /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#mainmenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleNavbar('navbar')"
      >
        <span class="navbar-toggler-icon"
          ><i class="fa fa-align-justify" aria-hidden="true"></i
        ></span>
      </button>
      <div
        class="collapse navbar-collapse"
        id="mainmenu"
        :class="responsiveNav ? 'show' : ''"
      >
        <ul class="navbar-nav ml-auto" id="mymenu">
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/index#home"
              >Home</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/index#about"
              >about</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/index#feature"
              >feature</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/index#screenshots"
              >screenshot</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/index#team"
              >team</router-link
            >
          </li>
          <li class="nav-item dropdown" @click="toggleNavbar('blogList')">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >Blog</a
            >
            <ul class="dropdown-menu" :class="responsiveBlogList ? 'show' : ''">
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/blog-list"
                  >blog list</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/blog-details"
                  >blog details</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/blogs-leftside"
                  >leftsidebar</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/blogs-rightside"
                  >rightsidebar</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  to="/chatloop/blog-details-with-left-sidebar"
                  >details leftsidebar
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  to="/chatloop/blog-details-with-right-sidebar"
                  >details rightsidebar
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/chatloop/index#contact"
              >contact us</router-link
            >
          </li>
          <li class="nav-item dropdown" @click="toggleNavbar('otherPagesList')">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >Other Page</a
            >
            <ul
              class="dropdown-menu"
              :class="responsiveOthePageslist ? 'show' : ''"
            >
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/sign-in"
                  >Sign In</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/sign-up"
                  >Sign Up</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/forgot-password"
                  >Forget Password</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/thank-you"
                  >Thank You</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/review"
                  >Review</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/FAQ-page"
                  >FAQ</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/coming-soon"
                  >Coming Soon</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/download"
                  >Download</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/request"
                  >Request Demo</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/chatloop/404"
                  >404</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "Navbar",
  data() {
    return {
      scrollpage: 0,
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
    };
  },
  methods: {
    handleScroll: function (event) {
      this.scrollpage = window.scrollY;
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>
<style></style>
